import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { animate, style, transition, trigger, state } from '@angular/animations';

@Component({
  selector: 'dropdown-list',
  templateUrl: './dropdown-list.component.html',
  styleUrls: ['./dropdown-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    // arrow animation
    trigger('toggleArrow', [
      state('collapsed', style({ transform: 'rotate(0)' })),
      state('expanded', style({ transform: 'rotate(-180deg)' })),
      transition('expanded => collapsed', animate('500ms ease')),
      transition('collapsed => expanded', animate('500ms ease'))
    ])
  ]
})
export class DropdownListComponent {

  @Input() placeholder: string = '';
  @Input() values: string[] = [];

  @Input() value: string = '';
  @Output() valueChange: EventEmitter<string> = new EventEmitter();

  @Input() error: boolean = false;
  
  protected arrowState = 'collapsed';

  constructor(private ref: ChangeDetectorRef) {}

  public onToggle(): void {
    this.arrowState = this.arrowState === 'collapsed' ? 'expanded' : 'collapsed';
  }

  public selectValue(value: string) {
    this.arrowState = 'collapsed';
    this.value = value;
    this.valueChange.emit(value);
    this.ref.markForCheck();
  }
}
